module.exports = __webpack_public_path__ + "media/images/creator/story_count_achievement_mailer/ogp_image_10-9d57ae10a5408fc690f931f78653ec38.png";